import React from "react"

import { createIcon } from "@chakra-ui/react"

export const TiktokIcon = createIcon({
  displayName: "TikTok",
  viewBox: "0 0 352.28 398.67",
  path: (
    <>
      <path
        fill="#25f4ee"
        d="M137.17,156.98v-15.56c-5.34-.73-10.76-1.18-16.29-1.18C54.23,140.24,0,194.47,0,261.13c0,40.9,20.43,77.09,51.61,98.97-20.12-21.6-32.46-50.53-32.46-82.31,0-65.7,52.69-119.28,118.03-120.81Z"
      />
      <path
        fill="#25f4ee"
        d="M140.02,333c29.74,0,54-23.66,55.1-53.13l.11-263.2h48.08c-1-5.41-1.55-10.97-1.55-16.67h-65.67l-.11,263.2c-1.1,29.47-25.36,53.13-55.1,53.13-9.24,0-17.95-2.31-25.61-6.34,10.03,13.91,26.33,23.01,44.75,23.01Z"
      />
      <path
        fill="#25f4ee"
        d="M333.13,106v-14.63c-18.34,0-35.43-5.45-49.76-14.8,12.76,14.65,30.09,25.22,49.76,29.43Z"
      />
      <path
        fill="#fe2c55"
        d="M283.38,76.57c-13.98-16.05-22.47-37-22.47-59.91h-17.59c4.63,25.02,19.48,46.49,40.06,59.91Z"
      />
      <path
        fill="#fe2c55"
        d="M120.88,205.92c-30.44,0-55.21,24.77-55.21,55.21,0,21.2,12.03,39.62,29.6,48.86-6.55-9.08-10.45-20.18-10.45-32.2,0-30.44,24.77-55.21,55.21-55.21,5.68,0,11.13,.94,16.29,2.55v-67.05c-5.34-.73-10.76-1.18-16.29-1.18-.96,0-1.9,.05-2.85,.07v51.49c-5.16-1.61-10.61-2.55-16.29-2.55Z"
      />
      <path
        fill="#fe2c55"
        d="M333.13,106v51.04c-34.05,0-65.61-10.89-91.37-29.38v133.47c0,66.66-54.23,120.88-120.88,120.88-25.76,0-49.64-8.12-69.28-21.91,22.08,23.71,53.54,38.57,88.42,38.57,66.66,0,120.88-54.23,120.88-120.88V144.33c25.76,18.49,57.32,29.38,91.37,29.38V108.03c-6.57,0-12.97-.71-19.14-2.03Z"
      />
      <path d="M241.76,261.13V127.66c25.76,18.49,57.32,29.38,91.37,29.38v-51.04c-19.67-4.21-37-14.77-49.76-29.43-20.58-13.42-35.43-34.88-40.06-59.91h-48.08l-.11,263.2c-1.1,29.47-25.36,53.13-55.1,53.13-18.42,0-34.72-9.1-44.75-23.01-17.57-9.25-29.6-27.67-29.6-48.86,0-30.44,24.77-55.21,55.21-55.21,5.68,0,11.13,.94,16.29,2.55v-51.49c-65.34,1.53-118.03,55.11-118.03,120.81,0,31.78,12.34,60.71,32.46,82.31,19.63,13.78,43.52,21.91,69.28,21.91,66.65,0,120.88-54.23,120.88-120.88Z" />
    </>
  ),
})

export const TiktokMonoIcon = createIcon({
  displayName: "TikTok",
  viewBox: "0 0 347.67 398.67",
  path: (
    <>
      <path d="M295.74,79.91c-21.48-14-36.97-36.41-41.81-62.52-1.04-5.64-1.62-11.45-1.62-17.39h-68.54l-.11,274.68c-1.15,30.76-26.47,55.45-57.5,55.45-9.65,0-18.73-2.41-26.73-6.62-18.34-9.65-30.89-28.87-30.89-50.99,0-31.77,25.85-57.62,57.61-57.62,5.93,0,11.62,.98,17,2.66v-69.97c-5.57-.76-11.23-1.23-17-1.23C56.59,146.36,0,202.95,0,272.52c0,42.68,21.32,80.45,53.86,103.29,20.49,14.39,45.42,22.86,72.3,22.86,69.56,0,126.15-56.59,126.15-126.15V133.23c26.88,19.29,59.82,30.66,95.36,30.66V95.35c-19.14,0-36.97-5.69-51.93-15.44Z" />
    </>
  ),
})
